<template>
    <div v-if="isGroupRegistrar" class="mb-3">
        <h2>
            <template v-if="changeWordingRegistrationBuy">
                {{$t('eventRegistration.summary.finishGroupBuy')}}
            </template>
            <template v-else>
                {{$t('eventRegistration.summary.finishGroupRegistration')}}
            </template>
        </h2>
        <base-switch v-model="finishGroupRegistration">
            <template v-if="changeWordingRegistrationBuy">
                {{$t('eventRegistration.summary.finishGroupBuy')}}
            </template>
            <template v-else>
                {{$t('eventRegistration.summary.finishGroupRegistration')}}
            </template>
        </base-switch>
        <div>
            <template v-if="changeWordingRegistrationBuy">
                {{$t('eventRegistration.summary.finishGroupBuyExplanation')}}
            </template>
            <template v-else>
                {{$t('eventRegistration.summary.finishGroupRegistrationExplanation')}}
            </template>
        </div>
    </div>
</template>

<script>

    import mainRegistrationMixin from "@/mixins/registration/mainRegistrationMixin";
    import registrationGroupMixin from "@/mixins/registration/registrationGroupMixin";
        import registrationOnlineRegistrationFieldsMixin
        from "@/mixins/registration/registrationOnlineRegistrationFieldsMixin";

    export default {
        name: "GroupRegistration",
        mixins: [mainRegistrationMixin, registrationGroupMixin, registrationOnlineRegistrationFieldsMixin],
        computed: {
            finishGroupRegistration: {
                get: function () {
                    return this.registrationData.finishGroupRegistration
                },
                set: function (value) {
                    this.setRegistrationProp('finishGroupRegistration', value)
                }
            },
        }
    }
</script>

<style scoped>

</style>
